<template>
  <md-dialog class="filter-dialog" :md-active.sync="showModal">
    <button @click="close" class="close-button">
      <Times />
    </button>
    <div class="row">
      <div class="col-12 filter-container">
        <md-dialog-title>Filtrar por</md-dialog-title>
        <SelectInput
          class="sel-input"
          label="Vertical"
          name="vertical"
          id="vertical"
          v-model="vertical"
          v-if="verticales"
        >
          <md-option value="all">Todas las verticales</md-option>
          <md-option v-for="vert in verticales" :key="vert.id" :value="vert.id">{{vert.name}}</md-option>
        </SelectInput>

        <SelectInput
          class="sel-input"
          label="Batch"
          name="batch"
          id="batch"
          v-model="batch"
          v-if="batches"
        >
          <md-option value="all">Todos los batches</md-option>
          <md-option v-for="(bat, i) in batches" :key="i" :value="`${bat}`">{{''+bat}}</md-option>
        </SelectInput>
      </div>
    </div>
  </md-dialog>
</template>

<script>
import Times from '../assets/icons/times.svg';
import SelectInput from './Input/SelectInput.vue';

export default {
  name: 'FilterModal',
  props:{
    showDialog: Boolean,
    verticales: Array,
    batches: Array,
  },
  components: {
    Times,
    SelectInput,
  },
  data(){
    return {
      showModal: this.showDialog,
      vertical: 'all',
      batch: 'all',
    };
  },
  watch: {
    vertical(value){
      this.$emit('vertical', value);
    },
    batch(value){
      this.$emit('batch', value);
    },
    showDialog(value){
      this.showModal = value;
    },
    showModal(value){
      if(!value) this.$emit('close');
    },
  },
  methods: {
    close(){
      this.showModal = false;
      this.$emit('close');
    }
  }
};
</script>

<style scoped lang="scss">
.sel-input {
  margin-top: 30px !important;
}
.close-button {
  background: transparent;
  border: none;
  width: fit-content;
  margin-top: 15px;
  margin-left: 15px;
  cursor: pointer;
}
.filter-container {
  padding: 0 45px;
}
.filter-dialog {
  background: #ff5f3c;
  min-width: 100vw;
  height: 100vh;

  @media (min-width: 768px) {
    min-width: 500px;
  }

  .md-dialog-title.md-title {
    color: #fff;
    font-family: "Montserrat", sans-serif;
    font-weight: 600;
    padding: 0;
    margin: 15px 0;
    display: block;
  }
}
</style>
